import cns from 'classnames';
import { css } from '@emotion/react';
import { ReactNode } from 'react';
import styled from '@emotion/styled';
import { space, SpaceProps } from 'styled-system';

export const MODAL_BODY_CLASSNAME = '__mapui_modalBody';

export interface ModalBodyProps extends SpaceProps {
  children: ReactNode;
  className?: string;
}

const applyMainStyles = (theme) => {
  const body = css(theme.modal.body);

  const styles = [body];

  return css(...styles);
};

export const ModalBody = styled.div<ModalBodyProps>(
  ({ theme }) => ({
    ...applyMainStyles(theme),
  }),
  ({ className }) => ({
    className: cns(MODAL_BODY_CLASSNAME, className),
  }),
  space
);
